module.exports = __webpack_public_path__ + "voice-unmute.svg?a571f7e8da663cba6c163dd6f6bff045";